import { checkPermission } from "library/authorization/index.mjs"
import { AUTHORING_ADMIN_MAINTENANCE_REFERENCE_DOCUMENTS } from "routes/plugins/maintenance-reference-documents/server/constants.mjs"
import { FEATURE_FLAG_MAINTENANCE_REFERENCE_DOCUMENTS } from "routes/plugins/maintenance-reference-documents/server/feature-flag-maintenance-reference-documents.mjs"
import { REVIEW_PROJECTS_AUTHORING_ADMIN_DEMANDS } from "./server/constants.mjs"
import { FEATURE_FLAG_REVIEW_PROJECTS } from "./server/feature-flag-review-projects.mjs"

export function canAccessReviewProjectsArea() {
    if (!checkPermission(`$feature-${FEATURE_FLAG_REVIEW_PROJECTS}`)) return false
    if (canAccessProjectsTab()) return true

    return (
        checkPermission(`$${AUTHORING_ADMIN_MAINTENANCE_REFERENCE_DOCUMENTS}`) &&
        checkPermission(`$feature-${FEATURE_FLAG_MAINTENANCE_REFERENCE_DOCUMENTS}`)
    )
}

export function canAccessProjectsTab() {
    return checkPermission(REVIEW_PROJECTS_AUTHORING_ADMIN_DEMANDS, false)
}
